/**
 * Patriot tools — support-only views over the Patriot replica. The pages
 * themselves live in the app; this is the data they read and the rules for
 * reading it.
 */
export {
  useTenantActivations,
  useTenantActivation,
  useFleetActivations,
  useFleetActivation,
  useTenantSignals,
  ACTIVATIONS_PAGE_SIZE,
  SIGNALS_PAGE_SIZE,
  type UseTenantActivationsOptions,
  type UseFleetActivationsOptions,
  type UseActivationsResult,
  type UseActivationResult,
  type UseTenantSignalsOptions,
  type UseSignalsResult,
} from "./hooks";
export { parseTenantSignalFilters, type TenantSignalFilters } from "./signal-filters";
export {
  parseTenantActivationFilters,
  parseFleetActivationFilters,
  FLEET_DEFAULT_DAYS,
  type TenantActivationFilters,
  type FleetActivationFilters,
  type ParsedFleetActivationFilters,
  type ParsedTenantActivationFilters,
  type RawActivationFilters,
} from "./activation-filters";
export { activationCameraKey, chronological, formatElapsed } from "./activation-view";
export type { CursorPager } from "./cursor-pager";
export type {
  ActivationDetail,
  ActivationOperatorNote,
  ActivationSignal,
  ActivationSummary,
  FleetActivationDetail,
  FleetActivationSummary,
} from "../../client-messages/activations";
export type { SignalSummary } from "../../client-messages/signals";
